import React from 'react'

const NotFound = () => {
  return (
    <div className='text-4xl'>Page NotFound</div>
  )
}

export default NotFound